import React, { useState } from "react";
import {
  Card,
  CardContent,
  CardActions,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { AppButton } from "./ui";

/**
 * Props:
 * - guide: the raw guide object (has at least { sk, name })
 * - isOwner: boolean (controls which buttons you show/enable, if desired)
 * - onEdit(guideId: string)
 * - onClone(guide: object)
 * - onDelete(guideId: string): Promise/void
 */
const GuideCard = ({ guide, isOwner, onEdit, onClone, onDelete }) => {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);

  // Extract the actual guide id from the `sk` field: "GUIDE#{id}"
  const extractGuideId = (g) => g.sk.split("GUIDE#")[1];
  const guideId = extractGuideId(guide);

  const handleDeleteClick = () => setConfirmOpen(true);

  const handleConfirmDelete = async () => {
    try {
      setDeleting(true);
      await onDelete?.(guideId);
    } finally {
      setDeleting(false);
      setConfirmOpen(false);
    }
  };

  return (
    <>
      <Card>
        <CardContent>
          <Typography variant="h6">{guide.name}</Typography>
          <Typography variant="body2">ID: {guideId}</Typography>
        </CardContent>
        <CardActions>
          <AppButton size="small" kind="ghost" onClick={() => onEdit?.(guideId)}>
            Edit
          </AppButton>
          <AppButton size="small" kind="ghost" onClick={() => onClone?.(guide)}>
            Clone
          </AppButton>
          <AppButton size="small" kind="danger" onClick={handleDeleteClick} disabled={deleting}>
            Delete
          </AppButton>
        </CardActions>
      </Card>

      <Dialog
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        PaperProps={{ className: "guidesDialogPaper" }}
      >
        <DialogTitle>Delete this guide?</DialogTitle>
        <DialogContent>
          <Typography>This action cannot be undone. Are you sure you want to delete “{guide.name}”?</Typography>
        </DialogContent>
        <DialogActions>
          <AppButton kind="ghost" onClick={() => setConfirmOpen(false)} disabled={deleting}>
            Cancel
          </AppButton>
          <AppButton onClick={handleConfirmDelete} kind="danger" disabled={deleting}>
            {deleting ? "Deleting…" : "Delete"}
          </AppButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default GuideCard;
